import axios from 'axios';
import oktaAuthService from '../../auth/oktaAuthService';

const API_CONFIG = {
  baseURL:
    process.env.REACT_APP_API_URL ||
    'https://grainhedgingapi-qa.smithfield.com/api/',
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
};

const API_uploadCONFIG = {
  baseURL:
    process.env.REACT_APP_API_URL ||
    'https://grainhedgingapi-qa.smithfield.com/api/',
  responseType: 'json',
  headers: {
    Accept: 'application/json',
  },
};

const api = {
  client: axios.create(API_CONFIG),
  uploadclient: axios.create(API_uploadCONFIG),
};

export const initializeAPI = () => {};

export const initializeAPIwithAuthentication = async () => {
  try {
    // Initialize API instances with base configuration

    // Create new instances without auth headers first
    api.client = axios.create(API_CONFIG);
    api.uploadclient = axios.create(API_uploadCONFIG);

    // Add request interceptor to add token to every request
    api.client.interceptors.request.use(async (config) => {
      try {
        const accessToken = await oktaAuthService.getAccessToken();
        if (!accessToken) {
          // If no token, try to refresh
          await oktaAuthService.getOktaAuth().tokenManager.renew('accessToken');
          const newToken = await oktaAuthService.getAccessToken();
          if (newToken) {
            config.headers.Authorization = `Bearer ${newToken}`;
          } else {
            throw new Error('No access token available');
          }
        } else {
          config.headers.Authorization = `Bearer ${accessToken}`;
        }
        return config;
      } catch (error) {
        console.error('Error getting access token:', error);
        // Redirect to login if token refresh fails
        window.location.href = '/login';
        return Promise.reject(error);
      }
    });

    // Same for upload client
    api.uploadclient.interceptors.request.use(async (config) => {
      try {
        const accessToken = await oktaAuthService.getAccessToken();
        if (!accessToken) {
          // If no token, try to refresh
          await oktaAuthService.getOktaAuth().tokenManager.renew('accessToken');
          const newToken = await oktaAuthService.getAccessToken();
          if (newToken) {
            config.headers.Authorization = `Bearer ${newToken}`;
          } else {
            throw new Error('No access token available');
          }
        } else {
          config.headers.Authorization = `Bearer ${accessToken}`;
        }
        config.headers['Content-Type'] = 'multipart/form-data';
        return config;
      } catch (error) {
        console.error('Error getting access token:', error);
        window.location.href = '/login';
        return Promise.reject(error);
      }
    });

    // Add response interceptor to handle token refresh
    const responseInterceptor = async (error) => {
      if (error.response?.status === 401) {
        try {
          // Clear tokens and redirect to Okta login
          await oktaAuthService.signOut();
          window.location.href = '/login';
        } catch (e) {
          console.error('Error during sign out:', e);
        }
      }
      return Promise.reject(error);
    };

    api.client.interceptors.response.use(
      (response) => response,
      responseInterceptor
    );
    api.uploadclient.interceptors.response.use(
      (response) => response,
      responseInterceptor
    );
  } catch (error) {
    console.error('Failed to initialize API with authentication:', error);
    // Redirect to login if we can't get a token
    oktaAuthService.signOut();
  }
};

export default api;
